// Этот файл генерируется автоматически, его не следует редактировать вручную
import popup from '@/widgets/popup.js';
import revealText from '@/widgets/revealText.js';
import scrollTop from '@/widgets/scrollTop.js';
import scrollerHorizontal from '@/widgets/scrollerHorizontal.js';
import showPopupMenu from '@/widgets/showPopupMenu.js';
import smoothScroll from '@/widgets/smoothScroll.js';
import stickyHeader from '@/widgets/stickyHeader.js';
import tilesParallax from '@/widgets/tilesParallax.js';
import toggleClass from '@/widgets/toggleClass.js';

export default {
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/collapse.js'),
  'folder': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/folder.js'),
  'form': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "form" */ '@/widgets/form.js'),
  'formsConditional': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "form" */ '@/widgets/formsConditional.js'),
  'instructorsCarousel': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/instructorsCarousel.js'),
  'map': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/map.js'),
  'popup': async () => { return { default: popup }; },
  'revealText': async () => { return { default: revealText }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'scrollerHorizontal': async () => { return { default: scrollerHorizontal }; },
  'selectNotEmpty': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "form" */ '@/widgets/selectNotEmpty.js'),
  'showPopupMenu': async () => { return { default: showPopupMenu }; },
  'signedForm': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "signedForm" */ '@/widgets/signedForm.js'),
  'smoothScroll': async () => { return { default: smoothScroll }; },
  'stickyHeader': async () => { return { default: stickyHeader }; },
  'telField': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "form" */ '@/widgets/telField.js'),
  'tilesParallax': async () => { return { default: tilesParallax }; },
  'toggleClass': async () => { return { default: toggleClass }; },
  'upload': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "form" */ '@/widgets/upload.js')
};
